import _ from 'lodash';
import React, { Component, PropTypes } from 'react';
import { Row, Col } from 'react-bootstrap';
import DailyWeatherSummary from './DailyWeatherSummary';
import ComponentTitle from 'components/shared/ComponentTitle';
import VideoPlayer from 'components/media/VideoPlayer';

class DailySummaryWithVideo extends Component {
  static propTypes = {
    FRN_rawResponses: PropTypes.array,
    title: PropTypes.string,
    titleColor: PropTypes.string,
    dailySummaryProps: PropTypes.object,
    videoProps: PropTypes.object
  }

  render() {
    const {
      FRN_rawResponses: [
        dailySummaryData,
        videoPlayerData
        ] = [],
      title,
      titleColor,
      dailySummaryProps,
      videoProps
      } = this.props;

    const dailySummaryPropsWithData = _.assign(dailySummaryProps, {FRN_rawResponses: [dailySummaryData]});
    const videoPlayerPropsWithData = _.assign(videoProps, {FRN_rawResponses: [videoPlayerData]});

    return (
      <div className="heartland-weather-DailySummaryWithVideo">
        { title ? <ComponentTitle title={title} color={titleColor} classes="VideoPlayerModal-title" /> : null }
        <Row>
          <Col xs={12} md={3}>
            <VideoPlayer {...videoPlayerPropsWithData} />
          </Col>
          <Col xs={12} md={9}>
            <DailyWeatherSummary {...dailySummaryPropsWithData} />
          </Col>
        </Row>
      </div>
    );
  }
}

export default DailySummaryWithVideo;



// WEBPACK FOOTER //
// ./app/components/custom/heartland/weather/DailySummaryWithVideo.js